const utcToLocalTime = (dateString) => {
  try{
      //reformat yyyy-mm-dd to yyyy/mm/dd (not using regex to avoid replacing additional '-')
      dateString = dateString.replace("-","/").replace("-","/")
      if(!dateString.includes("UTC")){
          dateString += " UTC";
      }
      return new Date(dateString);

  }catch(e){
      return null;
  }
}

const toDateString = (date) => {
  const monthNames = ["January", "February", "March", "April", "May", "June",
  "July", "August", "September", "October", "November", "December"];
  date = monthNames[date.getMonth()] + " " + date.getDate() + ", " + date.getFullYear();
  return date;
}

export default {
  utcToLocalTime,
  toDateString,
}
